import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../../graphql/common.datatypes';

interface UpdateForgottenPasswordVars {
    data: {
        email: string,
        token: string,
        password: string,
        password_confirmation: string,
    }
}

interface UpdateForgottenPasswordData {
    updateForgottenPassword: StatusMessage
}

export const UPDATE_FORGOTTEN_PASSWORD_MUTATION = gql`
    mutation updateForgottenPassword($data: NewPasswordWithCodeInput!) {
        updateForgottenPassword(input: $data) {
            ${gqlStatusMessage}
        }
    }
`;

export const updateForgottenPassword = () => useMutation<UpdateForgottenPasswordData, UpdateForgottenPasswordVars>(
    UPDATE_FORGOTTEN_PASSWORD_MUTATION, {}
);

export default updateForgottenPassword;
